module.exports = __webpack_public_path__ + "b18cc9466a70dd0c583b5f5eee657d58.svg";